import {
  DELETE,
  POST,
  PUT,
} from "../../apiController";

const endpoint = "/admin/settings/faq";

// ------------------------------------------------------------- setting FAQ

// Get FAQs with pagination and search
export const getFAQs = (data) => {
  return POST(endpoint, data);
};

// Add new FAQ
export const addFAQ = (data) => {
  return POST(endpoint + `/add`, data);
};

// Update FAQ
export const updateFAQ = (id, data) => {
  return PUT(endpoint + `/${id}`, data);
};

// Update FAQ status (active/inactive)
export const updateFAQStatus = (id, data) => {
  return PUT(endpoint + `/status/${id}`, data);
};

// Delete FAQ (soft delete)
export const deleteFAQ = (id) => {
  return DELETE(endpoint + `/${id}`);
};
